/** The month as a person says it, in the locale's own case: «settembre 2026», «September 2026». */
export function monthLabel(period: string, language: string | undefined): string {
  const [year, month] = period.split('-').map(Number);
  if (year === undefined || month === undefined || Number.isNaN(year) || Number.isNaN(month)) {
    return period;
  }
  const name = new Intl.DateTimeFormat(language ?? 'it', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(Date.UTC(year, month - 1, 1));
  return name;
}

/** `YYYY-MM` moved by whole months, the way the period input itself steps. */
export function shiftMonth(period: string, delta: number): string {
  const [year, month] = period.split('-').map(Number);
  if (year === undefined || month === undefined || Number.isNaN(year) || Number.isNaN(month)) {
    return period;
  }
  const moved = new Date(Date.UTC(year, month - 1 + delta, 1));
  return `${moved.getUTCFullYear()}-${String(moved.getUTCMonth() + 1).padStart(2, '0')}`;
}
